import { UpdateAdminChannelInput } from '../../application/ports/IAdminChannelRepository'

const SENDING_TIME_ANCHOR_DATE = '2000-01-01'

export const toUpdateAdminChannelBody = (input: UpdateAdminChannelInput) => {
  const { sendingStartTime, sendingEndTime, ...rest } = input
  return {
    ...rest,
    ...(sendingStartTime !== undefined && { sendingStartTime: `${SENDING_TIME_ANCHOR_DATE}T${sendingStartTime}:00Z` }),
    ...(sendingEndTime !== undefined && { sendingEndTime: `${SENDING_TIME_ANCHOR_DATE}T${sendingEndTime}:59Z` }),
  }
}
